module.exports = __webpack_public_path__ + "img/179978.7d08a887.png";